import React, { PureComponent } from 'react';
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import IconButton from '@material-ui/core/IconButton';
import MailIcon from '@material-ui/icons/Mail';

import { useMatomo } from '@datapunt/matomo-tracker-react'

import L from "../util/L10n";
import EntryUrl from '../util/EntryUrl';
import InvisibleImg from '../a11y/InvisibleImg';

const useStyles = makeStyles((theme) => ({
    iconButton: {
        padding: 0,
        marginLeft: -10,
    },
    mailIcon: {
        fontSize: 48,
        transform: 'scale(0.643)',
        color: '#ffffff',
        backgroundColor: '#9d9d9d',
        borderRadius: 8,
        padding: 4,
    },
}));

class ShareEmailButton extends PureComponent {
    render() {
        const { classes, userLang, entry, trackShare } = this.props;
        const { title } = entry;
        const url = EntryUrl.getUrl(entry);
        const params = { title, url };
        const subject = L.t('shareEmailSubject', userLang, params);
        const body = L.t('shareEmailBody', userLang, params);
        const href = 'mailto:?subject=' + encodeURIComponent(subject) +
            '&body=' + encodeURIComponent(body);
        const altText = L.t('shareEmailAlt', userLang);
        return (
            <IconButton
                className={classes.iconButton}
                component='a'
                href={href}
                target='_blank'
                rel='noopener'
                onClick={() => {
                    trackShare(url);
                }}
            >
                <MailIcon
                    className={classes.mailIcon}
                />
                <InvisibleImg
                    alt={altText}
                />
            </IconButton>
        );
    }
}

ShareEmailButton.propTypes = {
    classes: PropTypes.object,
    entry: PropTypes.object,
    trackShare: PropTypes.func,
    userLang: PropTypes.string,
};

export default function _ShareEmailButton(props) {
    const classes = useStyles();
    const { trackEvent } = useMatomo();
    const onShare = (url) => {
        trackEvent({
            category: 'share',
            action: 'email',
            name: url,
        });
        return true;
    };
    return (
        <ShareEmailButton
            {...props}
            classes={classes}
            trackShare={onShare}
        />
    );
}
